<script>
    import { onMount } from "svelte";
    import Cinema from "../components/Cinema.svelte";
    import { withResolvers } from "@otto-ec/assets-core-utils/promise";
    import { renderBounceLayerRecommendationsInternal } from "../services/nexusInternal/internalNexusEvents.js";
    import { getFeatureOrder } from "../utils/externalTrackingHelper.js";

    let { data } = $props();
    let { recommendations, tracking, metaData, additionalClickTracking, featuresState, hasPersonalisedRecommendations } = data || {};
    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");
    let expandableCinemaHasLoaded = $state(false);
    let trackingEventMergeId = $state(null);
    let cinemaContainer;
    const [cinemaContainerMounted, mountSuccess] = withResolvers();

    onMount(() => {
        cinemaInjectionContainerWidth = parseInt(cinemaContainer?.offsetWidth) || 1000;
        featureIndex = getFeatureOrder(cinemaContainer);
        return renderBounceLayerRecommendationsInternal?.sub(
            (detail) => {
                expandableCinemaHasLoaded = true;
                trackingEventMergeId = detail?.eventMergeId;
                mountSuccess();
            },
            { once: true }
        );
    });
</script>

<div bind:this={cinemaContainer}>
    {#if expandableCinemaHasLoaded}
        <Cinema
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {featuresState}
            {cinemaInjectionContainerWidth}
            cinemaMeta={metaData}
            {trackingEventMergeId}
            loadedTrackingActionName="automatic"
            personalisedUser={hasPersonalisedRecommendations || false}
            {cinemaContainerMounted}
        />
    {/if}
</div>
